/*
 * @Author: tkp
 * @Date: 2021-11-20 16:39:42
 */
// 导入axios实例
import request from './request'
import { code_status } from './setting';
const http = { /**
    * methods: 请求方法
    * @param url 请求地址 
    * @param params 请求参数
    **/
    get(url) {
        const config = {
            method: 'get',
            url: url,
            'Content-Type': 'application/json; charset=utf-8'
        }
        return new Promise(function (resolve, reject) {
            request(config).then(res => {
                if (res.code == code_status.SUCCESS) {
                    resolve(res)
                } else if (res.code == code_status.PASSTOKEN) {
                    window.localStorage.clear()
                } else { }
            }).catch(reson => {
                if (reson.request.status === 403) {

                } else { }
            })
        })
    },
    post(url, params) {
        const config = {
            method: 'post',
            url: url,
            'Content-Type': 'application/json; charset=utf-8'
        }
        if (params) config.data = params
        return new Promise(function (resolve, reject) {
            request(config).then(res => {
                if (res.code == code_status.SUCCESS) {
                    resolve(res)
                } else if (res.code == code_status.PASSTOKEN) {
                    window.localStorage.clear()
                } else { }
            }).catch(reson => {
                if (reson.request.status === 403) {

                } else { }
            })
        })
    },
}
//导出
export default http


// WEBPACK FOOTER //
// ./src/utils/http.js